import React from "react";
import "../css/cards.css";
import { cardsData } from "../rawData/kidsAPI";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardHeader, Container } from "@mui/material";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Box from '@mui/material/Box';

const Cards = () => {
  return (
    <>
      <Box className="container cards-container">
        <Container className="main cardMain">
          {cardsData.map((item)=>
              <Card sx={{ width: "20rem", marginBottom:3}}>
              <CardActionArea>
                <CardHeader title={item.name}  sx={{backgroundColor:"#F5F5F5", textAlign:"center"}}/>
                <CardMedia
                  component="img"
                  src={item.image}
                  alt="Image Not Found"
                />
                <CardContent sx={{backgroundColor:"#F5F5F5", textAlign:"center"}}>
                  <Typography variant="p" component="div" sx={{fontSize:13}}>
                    {item.category}
                  </Typography>
                  <Typography variant="p" component="p" sx={{fontWeight:"bold"}}>
                    {item.footer}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          )}
         
        </Container>
      </Box>
    </>
  );
};

export default Cards;


